/**
 * Narration/script text for each guided-tutorial step — spoken via TTS and
 * shown in the step-text box. Kept as plain constants alongside the
 * tutorials module rather than in i18n; unlike the tutorial UI chrome
 * (Skip/Start/Cancel button labels, tutorial titles — still translated via
 * `translate()`/`locales/common/en/index.json`), this script text isn't
 * currently translated.
 */
export const TUTORIAL_TEXT = {
  navigationBasics: {
    step1: 'To walk forward press W on your keyboard',
    step2: 'To walk backward press S on your keyboard',
    step3: 'To turn left press A on your keyboard',
    step4: 'To turn right press D on your keyboard',
  },
  languageSettings: {
    step1: 'To change language, click on profile button',
    step2: 'Now click on settings option',
    step3: 'Click on language dropdown and select a language',
  },
  teleport: {
    step1: 'To teleport press T on your keyboard',
    step2: 'Select location',
  },
};
